// ============================================
// モジュール読み込み
// ============================================
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

// ============================================
// ヘッダースクロールアニメ
// ============================================

function headerScrollAnim() {
  const mediaQueryList = window.matchMedia("(min-width: 320px)");

  const listener = (event) => {
      if (event.matches) {
          window.addEventListener("scroll", function () {
              const header = document.getElementById("header");
              const scrollPosition = document.documentElement.scrollTop + window.innerHeight;
              const scrollPositionCurrent = document.documentElement.scrollTop;
              const pageHeight = document.documentElement.scrollHeight;

              if (pageHeight - scrollPosition <= 700) {
                  // スクロール位置がサイトの下から1204px以内の場合
                  header.classList.remove("js-upScroll");
                  if (!header.classList.contains("js-downScroll")) {
                      header.classList.add("js-downScroll");
                  }
              }else if(scrollPositionCurrent < 100){
                header.classList.remove("js-upScroll");
              } else {
                  // それより上の場合
                  header.classList.remove("js-downScroll");
                  if (!header.classList.contains("js-upScroll")) {
                      header.classList.add("js-upScroll");
                  }
              }
          });
      }
  };
  
  mediaQueryList.addEventListener("change", listener);
  listener(mediaQueryList);
}


// ==================================
//  ハンバーガーメニューの開閉
// ==================================
import MicroModal from "micromodal";


// ============================================
// ハンバーガーメニュー
// ============================================

function hamburger() {

  const hamburger = document.getElementById('hamburger');
  const drawer = document.getElementById('navigation');
  const header = document.getElementById('header');

  function toggleMenu(){
    hamburger.classList.toggle('is-active');
    drawer.classList.toggle('is-active');
    header.classList.toggle('is-active');

    //ボタンのaria-expanded属性を切り替える
    const isExpanded = hamburger.getAttribute("aria-expanded") === "true";
    hamburger.setAttribute(
      "aria-expanded",
      isExpanded ? "false" : "true"
    );

    //ボタンのaria-label属性を切り替える
    const isMenu = hamburger.getAttribute("aria-label") === "メニューを開く";
    hamburger.setAttribute(
      "aria-label",
      isMenu ? "メニューを閉じる" : "メニューを開く"
    );

    //ドロワーのaria-hidden属性を切り替える
    const isHidden = drawer.getAttribute("aria-hidden") === "true";
    drawer.setAttribute("aria-hidden", isHidden ? false : "true");

    document.body.style.overflow =
      document.body.style.overflow === "hidden" ? "" : "hidden";
  };

  // ハンバーガーメニューをクリックした時
  hamburger.addEventListener('click', toggleMenu);


  // Escキーが押された時
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") {
      toggleMenu();
    }
  });
}

// ============================================
// ローディング完了判定
// ============================================
function loadingFin() {
  window.addEventListener("load", () => {
    document.body.classList.add("is-loaded");
  });
}

// ============================================
// リサイズ判定処理
// ============================================
function resizeCheck() {

  //ヘッダー高さ取得

  const header = document.getElementById("header");
  const height = header.clientHeight;

  function getHeaderHeight() {
    document.documentElement.style = "--header-height: " + height + "px";
  }
  getHeaderHeight();

  window.addEventListener("resize", function () {
    getHeaderHeight();

    //リサイズでアニメーションとめる
    document.body.classList.add("is-resize");
    setTimeout(function () {
      document.body.classList.remove("is-resize");
    }, 500);
  });
}

// ============================================
// MVアニメーション
// ============================================

function mvAnime(){

  const elements = document.querySelectorAll(".js-fade-in");
  elements.forEach((element, index) => {    
    const delay = parseInt(element.getAttribute('data-delay'));
    setTimeout(() => {
      element.classList.add('is-show');
    }, delay);
  });
}


// ============================================
// アコーディオンメニュー
// ============================================

  function setUpAccordion(){
    const details = document.querySelectorAll('.l-drawer__acc-content');
    const RUNNING_VALUE = 'running'; // アニメーション実行中のときに付与する予定のカスタムデータ属性の値
    const IS_OPENED_CLASS = 'is-open'; // アイコン操作用のクラス名

    details.forEach((element) => {
      const summary = element.querySelector('summary');
      const content = element.querySelector('summary + div');

      if (!summary){ return false;}

      summary.addEventListener('click', (event) => {
        // デフォルトの挙動を無効化
        event.preventDefault();

        // 連打防止用。アニメーション中だったらクリックイベントを受け付けないでリターンする
        if (element.dataset.animStatus === RUNNING_VALUE) {
          return;
        }

        // detailsのopen属性を判定
        if (element.open) {
          // アコーディオンを閉じるときの処理
          // アイコン操作用クラスを切り替える(クラスを取り除く)
          element.classList.toggle(IS_OPENED_CLASS);

          // アニメーションを実行
          const closingAnim = content.animate(closingAnimKeyframes(content), animTiming);
          // アニメーション実行中用の値を付与
          element.dataset.animStatus = RUNNING_VALUE;

          // アニメーションの完了後に
          closingAnim.onfinish = () => {
            // open属性を取り除く
            element.removeAttribute('open');
            // アニメーション実行中用の値を取り除く
            element.dataset.animStatus = '';
          };
        } else {
          // アコーディオンを開くときの処理
          // open属性を付与
          element.setAttribute('open', 'true');

          // アイコン操作用クラスを切り替える(クラスを付与)
          element.classList.toggle(IS_OPENED_CLASS);

          // アニメーションを実行
          const openingAnim = content.animate(openingAnimKeyframes(content), animTiming);
          // アニメーション実行中用の値を入れる
          element.dataset.animStatus = RUNNING_VALUE;

          // アニメーション完了後にアニメーション実行中用の値を取り除く
          openingAnim.onfinish = () => {
            element.dataset.animStatus = '';
          };
        }
      });
    });
  };

  /**
   * アニメーションの時間とイージング
   */
  const animTiming = {
    duration: 300,
    easing: 'ease-out',
  };

  /**
   * アコーディオンを閉じるときのキーフレーム
   */
  const closingAnimKeyframes = (content) => [
    {
      height: content.offsetHeight + 'px', // height: "auto"だとうまく計算されないため要素の高さを指定する
      opacity: 1,
    },
    {
      height: 0,
      opacity: 0,
    },
  ];

  /**
   * アコーディオンを開くときのキーフレーム
   */
  const openingAnimKeyframes = (content) => [
    {
      height: 0,
      opacity: 0,
    },
    {
      height: content.offsetHeight + 'px',
      opacity: 1,
    },
  ];

// ============================================
// モーダル
// ============================================

function openModal() {
  MicroModal.init({
    disableScroll: true,
    onShow: (modal) => {
      const modalContent = modal.querySelector('.p-hm-modal__container');
      if (modalContent) {
        modalContent.scrollTop = 0;
        // モーダルコンテナにフォーカスを設定
        modalContent.focus();
      }
    },
  });
}

// ============================================
// サイドバー
// ============================================

/**
 * sectionのidを自動取得してセクションナビを動的生成（[id^=sec-]のものに限る）
 */
function stickySidebar() {

  function createSectionNav() {
      const nav = document.getElementById("js-section-tracker-nav");
      const sectionList = document.querySelectorAll("[id^=sec]");
      const navMain = document.querySelector(".l-sidebar__tracker-nav-main");
      if (!nav) return;

      // ナビゲーションのHTML文字列を格納して生成する
      let htmlTxt = "";
      htmlTxt += '<ul class="l-sidebar__tracker-nav-list">';

      // sectionごとに処理をし、見出しを元にナビゲーションのHTMLを作成する
      sectionList.forEach((section) => {
        const h2 = section.querySelector(".get-title.wp-block-heading");
        if (!h2) return;

        // 自動で見出しのidを作成
        const h2Id = `nav-${section.id}`;
        h2.id = h2Id;

        // 使用例
        const text = h2.textContent.trim();
        htmlTxt += `<li class="l-sidebar__tracker-nav-item" data-tracker="${section.id}">
                      <a class="l-sidebar__tracker-nav-link" href="#${h2Id}">${text}</a>`;
        htmlTxt += "</li>";
      });
      htmlTxt += "</ul>";

      // 完成したHTMLで置き換え
      navMain.innerHTML = htmlTxt;

      // ScrollTriggerによるカレントの付け替え処理を登録
      sectionList.forEach((section) => {
        ScrollTrigger.create({
          trigger: section,
          start: "top 30%",
          end: "bottom 30%",
          //markers: true,
          toggleClass: {
            targets: `[data-tracker="${section.id}"]`,
            className: "is-current",
          },
        });
      });
  }
  createSectionNav()

  /**
   * サイドバーをsticky表示
   */
  function pinSidebar() {
    // メディアクエリを作成
    let mm = gsap.matchMedia();
    const sidebar =document.querySelector('.js-sticky-sidebar');
  
    mm.add("not all and (max-width: 1024px)", () => {

      if (!sidebar){ return false;}

      gsap.to(".js-sticky-sidebar", {
        scrollTrigger: {
          trigger: ".js-sticky-sidebar",
          start: `top-=100 top`,
          end: "bottom+=300 bottom",
          endTrigger: ".l-page__main",
          pin: true,
          pinSpacing: false,
          // markers: true,
        },
      });
    });
  }
  pinSidebar()
}


// ============================================
// 廃棄物対象別事業 タブ切り替え
// ============================================

const tabs = document.querySelectorAll('.js-tab');

function tabSwitch(){

  let tabsArray = Array.prototype.slice.call(tabs);
  let tabPanels = document.querySelectorAll('.js-tab-panel');
  const balloons = document.querySelectorAll('.p-service__balloon');
  let index = tabsArray.indexOf(this);
  const hash = location.hash;

  const resetTab = function(){
    document.querySelector('.js-tab.is-active').classList.remove('is-active');
    document.querySelector('.js-tab[aria-selected=true]').removeAttribute('aria-selected');
    document.querySelectorAll('.js-tab').forEach((elm)=>{
      elm.tabIndex = -1;
    });
    document.querySelector('.js-tab-panel.is-active').classList.remove('is-active');
    document.querySelector('.p-service__balloon.is-active')?.classList.remove('is-active');
  }

  const setTab = function(tab,tabpanel,balloon) {
    tab.classList.add('is-active');
    tab.tabIndex = 0;
    tab.setAttribute('aria-selected',true);
    tabpanel.classList.add('is-active');
    balloon.classList.add('is-active');
    ScrollTrigger.refresh()
  }

  tabsArray.forEach((tab, index) => {
    tab.addEventListener('keyup', function(event) {
      // 右矢印が押された時
      if (event.key === 'ArrowRight') {
        const nextIndex = index + 1 > tabsArray.length - 1 ? 0 : index + 1 ;
        const nextTab = tabsArray[nextIndex];
        nextTab.focus();
        resetTab();
        setTab(nextTab, tabPanels[nextIndex],balloons[nextIndex]);
      }
  
      // 左矢印が押された時
      if (event.key === 'ArrowLeft') {
        const prevIndex = index - 1 >= 0 ? index - 1 : tabsArray.length - 1;
        const prevTab = tabsArray[prevIndex];
        prevTab.focus();
        resetTab();
        setTab(prevTab, tabPanels[prevIndex],balloons[prevIndex]);
      }
    });
  });

  tabs.forEach((tab, index) => {

    //ハッシュ値でタブを開く
    if(hash){
      //サイクルだけ例外処理
      if(hash==='#nav-sec-recycle'){
        resetTab();
        const tab_industry = document.getElementById("tab-industry");
        setTab(tab_industry, tabPanels[1],balloons[1]);
      }else{
        if(hash===`#${tab.id}`){
          resetTab();
            setTab(tab, tabPanels[index],balloons[index]);
        }
      }
    };

    tab.addEventListener('click', function() {
      resetTab();
      setTab(tab, tabPanels[index],balloons[index]);
    });
  });


  document.addEventListener('DOMContentLoaded', function() {
    var trigger = document.querySelectorAll(".l-sidebar__tracker-nav-link");
    trigger.forEach((target) => {
      target.addEventListener('click', (e) => {
        let hashtgt = target.getAttribute('href');

        if(hashtgt === '#nav-sec-recycle'){
          resetTab();
          const tab_industry = document.getElementById("tab-industry");
          setTab(tab_industry, tabPanels[1],balloons[1]);

          targetElm = document.getElementById("sec-recycle");
           //ヘッダー高さ取得
          const header = document.getElementById("header");
          const height = header.clientHeight;
          const targetRect = targetElm.getBoundingClientRect().top;
          let fixGutter = height;

          const targetPos = targetRect + window.scrollY - fixGutter - 30;
          const smooth = true;
          window.scrollTo({
            top: targetPos,
            behavior: smooth ? 'smooth' : 'auto',
          });

        }
      });
    });
  });

};

// ============================================
// スクロールヒント
// ============================================

function scrollHint(){

  const mapWrap = document.querySelector('.p-hm-service__map-wrap')
  if (!mapWrap){ return false;}
  mapWrap.addEventListener('scroll', function() {

    
    var scrollIcon = document.querySelector('.p-hm-service__scroll-hint');
    var isScrollingHorizontally = this.scrollWidth > this.clientWidth; // 横スクロールが発生しているかどうか
    var isScrollingVertically = this.scrollHeight > this.clientHeight; // 縦スクロールが発生しているかどうか
  
    if (isScrollingHorizontally || isScrollingVertically) {
      scrollIcon.classList.add('is-hidden');
    }

  });
  
}

// ============================================
// 数値カウントアップ
// ============================================

function countUp() {
  const cards = document.querySelectorAll(
    ".p-recruit-about__content-item"
  );
  if (!cards) return;
  cards.forEach((card) => {
    const numDom = card.querySelector(".p-recruit-about__num");

    //初期の数字を取得
    const num = numDom.innerText;
    numDom.innerText = 0;
    //カウントアップ止める用のフラッグ
    let flag = true;

    gsap.to(card, {
      scrollTrigger: {
        trigger: card,
        start: "80% bottom",
        onEnter: function () {
          function createRomdomNum() {
            //ランダムな数字を生成
            const randomNum1 = Math.floor(Math.random() * 10);
            const randomNum2 = Math.floor(Math.random() * 10);

            //ランダム数字表示
            numDom.innerText = String(randomNum1) + String(randomNum2);
            const loop = () => {
              setTimeout(createRomdomNum, 10);
            };

            //もしフラッグがtrueだったらランダム数字を再表示
            if (flag) {
              loop();
            }

            //一定時間経過後にランダム数字表示をストップ・正しい数字を入れる
            const time = 1000;
            setTimeout(() => {
              flag = false;
              numDom.innerText = num;
            }, time);
          }
          createRomdomNum();
        },
        once: true,
      },
    });
  });
}

// ============================================
// ハッシュリンククリック時smooth、 headerガター調整
// ============================================

function hashLinkSmoothScroll() {

  const anchorLinks = document.querySelectorAll('a[href*="#"]');
  anchorLinks.forEach((link) => {
    link.addEventListener('click', (e) => {
      // URLからベースURLを削除して、純粋なハッシュを取得
      const currentUrl = window.location.href.split('#')[0]; // 現在のURLのベース部分
      const targetUrl = link.href.split('#')[0]; // リンクのURLのベース部分

      if (currentUrl === targetUrl) { // リンクが現在のページを指しているかチェック
        const hash = link.hash;
        const targetElm = document.querySelector(hash);
        if (targetElm) {
          e.preventDefault(); // デフォルトの動作をキャンセル
          _scrollToTarget(targetElm);
        }
      } // それ以外の場合、通常のリンクとして機能させる（何もしない）
    });
  });


  // アンカー付きでページ遷移した場合
  const urlHash = location.hash;
  if (urlHash) {
    const targetElm = document.querySelector(urlHash);

    window.addEventListener('load', () => {
      _scrollToTarget(targetElm);
    });
  }

  // 引数のターゲットをもとに画面スクロールする関数
  function _scrollToTarget(targetElm, smooth = true) {
    if (targetElm) {
        //ヘッダー高さ取得
      const header = document.getElementById("header");
      const height = header.clientHeight;
      const targetRect = targetElm.getBoundingClientRect().top;
      let fixGutter = height;

      const targetPos = targetRect + window.scrollY - fixGutter - 30;

      window.scrollTo({
        top: targetPos,
        behavior: smooth ? 'smooth' : 'auto',
      });
    }
  }
}

// ============================================
// ドラッグスクロール
// ============================================

function mouseDrag(element){
  let target;
  const elms = document.querySelectorAll(element);
  for(let i=0; i<elms.length; i++){
    elms[i].addEventListener('mousedown', function(evt){
      evt.preventDefault();
      target = elms[i];
      target.dataset.down = 'true';
      target.dataset.move = 'false';
      target.dataset.x = evt.clientX;
      target.dataset.y = evt.clientY;
      target.dataset.scrollleft = target.scrollLeft;
      target.dataset.scrolltop = target.scrollTop;
      evt.stopPropagation();
    });
    elms[i].addEventListener('click', function(evt){
      if(elms[i].dataset != null && elms[i].dataset.move == 'true') evt.stopPropagation();
    });
  }
  document.addEventListener('mousemove', function(evt){
    if(target != null && target.dataset.down == 'true'){
      evt.preventDefault();
      let move_x = parseInt(target.dataset.x) - evt.clientX;
      let move_y = parseInt(target.dataset.y) - evt.clientY;
      if (move_x !== 0 || move_y !== 0) {
        target.dataset.move = 'true';
      } else {
        return;
      }
      target.scrollLeft = parseInt(target.dataset.scrollleft) + move_x;
      target.scrollTop = parseInt(target.dataset.scrolltop) + move_y;
      evt.stopPropagation();
    }
  });
  document.addEventListener('mouseup', function(evt){
    if(target != null && target.dataset.down == 'true'){
      target.dataset.down = 'false';
      evt.stopPropagation();
    }
  });
}



export {loadingFin, resizeCheck, hamburger,openModal,tabSwitch,mvAnime,scrollHint,countUp,setUpAccordion,stickySidebar,hashLinkSmoothScroll,headerScrollAnim,mouseDrag};

